import React from 'react';
import { mergeClassNames } from '../../utils/mergeClassNames';
import styles from './VideoBG.module.scss';


export class VideoBG extends React.Component<React.DetailedHTMLProps<React.VideoHTMLAttributes<HTMLVideoElement>, HTMLVideoElement>>
{
	private _video:HTMLVideoElement;

	render()
	{
		let props:Object = Object.assign({}, this.props);
		props['className'] = mergeClassNames([...(props['className'] || '').split(' '), 'video'], styles);

		return (
			<div className={mergeClassNames(['videoWrapper'], styles)}>
				<video ref={r => this._video = r} {...props}>
					{this.props.children}
				</video>
			</div>
		);
	}
}